module.exports = "/fonts/fa-regular-400.woff?e5770f9863963fb576942e25214a226d";